var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecharge2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 657.03596,
    height: 776.13897,
    viewBox: "0 0 657.03596 776.13897",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M916.98312,822.59834a50.79382,50.79382,0,0,1-13.58984,12.63c-1.12012.71-2.27,1.38-3.43994,2H872.42355c.32959-.66.64991-1.33.96-2a95.35446,95.35446,0,0,0-19.84034-109.34c16.64014,5.14,32.02,15.16,42.08008,29.37006a64.46956,64.46956,0,0,1,10.23,23,96.27571,96.27571,0,0,0-7.66992-48.41c13.50977,10.99,24.03027,26.04,28.04,42.98C930.23312,789.77833,927.32346,808.58833,916.98312,822.59834Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "b35682e1-9f03-403a-b8b0-c3d37d0d1380-256",
    "data-name": "Path 2533",
    d: "M928.136,838.06948H670.398v-2.106h258.12Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M580.23,325.2c0,38.64-13.5,71.63-39.19,96.18-18.23,17.43-46.31,41.86-46.31,67.69v21.37h-85.5V489.07c0-26.1-28.19-50.58-46.31-67.69-25.11-23.69-39.19-58.92-39.19-96.18v-.79a128.25061,128.25061,0,0,1,256.5.79Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#f9a826"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "ecc2cf6c-8ee8-498c-972d-3c77e28b77e9-257",
    "data-name": "Path 2546",
    d: "M494.729,513.44052a3,3,0,0,1-3-3v-21.374c0-25.125,24.779-48.58,42.873-65.706,1.5-1.422,2.961-2.8,4.363-4.145,25.029-23.928,38.259-56.437,38.259-94.014,0-70.229-55.013-125.243-125.242-125.243h-.354A125.03,125.03,0,0,0,326.739,324.49652v.7c0,36.8,13.939,71.063,38.245,94.007,1.231,1.163,2.51,2.36,3.823,3.589,18.327,17.159,43.427,40.658,43.427,66.275v21.373a3,3,0,0,1-6,0v-21.374c0-23.015-24-45.486-41.528-61.9q-1.9785-1.851-3.841-3.605c-25.5-24.072-40.126-59.924-40.126-98.364v-.72c.2-72.045,58.885-130.523,130.88-130.523h.371A130.557,130.557,0,0,1,583.22407,323.83091q.00357.68526-.00006,1.3706c0,39.255-13.871,73.264-40.112,98.351-1.409,1.347-2.876,2.736-4.386,4.165-17.3,16.377-41,38.806-41,61.349v21.374a3,3,0,0,1-3,3Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "b22bef41-3cd7-4c1e-881c-c9a642005cb0-258",
    "data-name": "Path 2547",
    d: "M480.481,551.93552h-57a5,5,0,1,1,0-10h57a5,5,0,0,1,0,10Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#f9a826"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M458.10991,585.43538H445.84282a23.44664,23.44664,0,0,1-12.09412-3.35059,2.79354,2.79354,0,0,1-1.26831-3.21435,2.8865,2.8865,0,0,1,2.80164-2.14209h33.38891a2.88664,2.88664,0,0,1,2.80176,2.14209,2.79336,2.79336,0,0,1-1.26856,3.21435A23.44509,23.44509,0,0,1,458.10991,585.43538Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M480.49077,567.72932l-57.33814-.00634-.17761-.38086a4.726,4.726,0,0,1,.89978-4.05811,4.85563,4.85563,0,0,1,3.82288-1.84863h48.55773a4.855,4.855,0,0,1,3.82325,1.84912,4.698,4.698,0,0,1,.91089,4.00732l-.09009.38623Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "e0eb6627-54a4-4797-861b-0d156b8b485b-259",
    "data-name": "Path 2548",
    d: "M319.381,207.34151a4.98,4.98,0,0,1-3.286-1.233l-42.939-37.481a5,5,0,0,1,6.576-7.533l42.939,37.481a5,5,0,0,1-3.29,8.767Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#e4e4e4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "e13fc22b-cd18-4b6e-a2d4-df4b74c6b7e7-260",
    "data-name": "Path 2549",
    d: "M577.45905,207.34151a5,5,0,0,1-3.29-8.767l42.93792-37.484a5,5,0,0,1,6.576,7.533l-42.939,37.481A4.98,4.98,0,0,1,577.45905,207.34151Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#e4e4e4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "a74da646-4683-465e-97fe-dd817e7fc328-261",
    "data-name": "Path 2550",
    d: "M494.729,534.19052h-85.5a5,5,0,0,1,0-10h85.5a5,5,0,0,1,0,10Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#f9a826"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M449.88,403.57,432.1,510.44H421.95l18.06-108.51a5.00266,5.00266,0,0,1,9.87,1.64Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M484.05,510.44H473.9L456.12,403.57a5.00266,5.00266,0,0,1,9.87-1.64Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "be3a5c8a-fbb4-472c-819b-e8dd06032f6a-262",
    "data-name": "Path 2551",
    d: "M419.48452,400a5,5,0,0,1,5-5h54.993a5,5,0,0,1,0,10h-54.993A5,5,0,0,1,419.48452,400Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "e9f776ed-f4b6-47dc-b212-c247d99ecb23-263",
    "data-name": "Path 2553",
    d: "M451.981,157.43052a5,5,0,0,1-5-5v-85.5a5,5,0,0,1,10,0v85.5A5,5,0,0,1,451.981,157.43052Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#e4e4e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "eba1f826-879a-4c25-b118-6bb025be95d0-264",
    "data-name": "Path 2559",
    d: "M860.701,824.07953H848.443l-5.832-47.288h18.092Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#feb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "f6694a1b-3521-46e6-aa9c-51f4297aac52-265",
    "data-name": "Path 2560",
    d: "M863.82805,835.96354H824.297v-.5a15.387,15.387,0,0,1,15.385-15.386h24.146Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "fae71c2d-33fb-45f7-8331-19b4de5eddc8-266",
    "data-name": "Path 2561",
    d: "M767.564,823.67553l-11.844-3.167,6.58-47.19,17.48,4.674Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#feb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "b3b10fd6-5fa4-49f3-8270-96ad6a3a1e0e-267",
    "data-name": "Path 2562",
    d: "M767.515,835.96354l-38.189-10.212.129-.483a15.387,15.387,0,0,1,18.839-10.89h0l23.325,6.237Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "f6267da0-acb1-421a-9dac-5a6151c1f955-268",
    "data-name": "Path 2563",
    d: "M867.754,559.06753l10.269,11.931-13.28,242.442h-28.369l-14.3-186.551-44.349,191.554-29.492-7.233,26.816-243.3Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "ea0dabd6-18d7-4484-8048-4cddc34702bd-269",
    "data-name": "Path 2564",
    d: "M781.905,402.54252l28.246-14.172,43.437.764,37.38,19.127L869.7,514.4795l9.187,55.38h0a226.53255,226.53255,0,0,1-108.335.892l-.284-.068s21.114-74.916,12.126-97.779Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "a75b604a-8411-40e9-b5d3-81fba8b6e00c-270",
    "data-name": "Path 2565",
    d: "M863.621,345.93452a31.994,31.994,0,1,0,0,.237Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#feb8b8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "b97e8772-edf1-4d51-bb40-aaab108bf113-271",
    "data-name": "Path 2567",
    d: "M778.007,479.9835a11.462,11.462,0,0,0,16.65,5.627l57.353,30.318,1.857-13.971-55.73-32.863a11.524,11.524,0,0,0-20.131,10.889Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#feb8b8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "b7638692-4395-4c34-bc33-e4b41c888504-272",
    "data-name": "Path 2568",
    d: "M854.436,482.39851a11.462,11.462,0,0,1-17.478,1.848l-62.6,17.035.545-17.738,62.27106-16.173a11.524,11.524,0,0,1,17.261,15.03Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#feb8b8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "fb7d8996-2760-43c1-a9a4-d402d6d3756c-273",
    "data-name": "Path 2569",
    d: "M878.762,409.0305l12.205-.765s14.29,18.855,6.364,39.316c0,0,1.373,73.5-30.276,70.48s-41.65-3.019-41.65-3.019l9.5-26.5,21.253-6.562s-6.55-28.894,5.849-40.916Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "a9eb06d8-8cbf-43ab-991d-4f9eccd60edd-274",
    "data-name": "Path 2570",
    d: "M790.63005,408.38551l-1.725-8.843s-25.44-.6-30.47,37.951c0,0-22.877,57.692-.454,65.121s47.089,0,47.089,0l-1.85711-25.444-24.67-5.033s12.745-16.489,5.805-30.792Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "ba7ab43e-494b-455d-a87f-0e0f24cb0a47-275",
    "data-name": "Path 2387",
    d: "M842.70445,361.6451c-2.35273-.92321-4.95894-.87527-7.44567-1.33105-8.89342-1.63849-15.75239-10.70648-14.90781-19.70962a10.84778,10.84778,0,0,0,.05763-3.5329c-.61621-2.569-3.47169-3.94789-6.09484-4.25558s-5.33331.086-7.885-.59694c-3.93954-1.05505-6.883-4.64835-7.88062-8.603a19.487,19.487,0,0,1,1.267-11.96329l1.22416,2.55209a9.91759,9.91759,0,0,0,2.5062-4.85275,6.25462,6.25462,0,0,1,5.16622,3.27253c1.58106.70614,1.388-2.90614,2.96395-3.621a2.95887,2.95887,0,0,1,2.10019.27339c3.47269,1.16515,7.156-.583,10.59739-1.83576a40.41732,40.41732,0,0,1,18.64164-2.13018c4.18269.51056,8.40506,1.74686,11.66025,4.41951a26.60667,26.60667,0,0,1,6.156,8.27393c4.017,7.50846,7.04316,15.79159,6.96075,24.30956a35.29808,35.29808,0,0,1-6.1645,19.5192c-2.052,2.98581-8.67978,13.34292-13.08484,12.20287C843.00869,372.607,849.32934,364.24347,842.70445,361.6451Z",
    transform: "translate(-271.48202 -61.93052)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecharge2);
export default __webpack_public_path__ + "static/media/recharge2.4240a9c2b1d67cd62c786692c0f73f31.svg";
export { ForwardRef as ReactComponent };